import React from 'react';
import { EventProvider } from './context/EventContext';
import './App.css';
import AdminPage from './pages/AdminPage';
import HomePage from './pages/HomePage';

function App() {
  const target = process.env.REACT_APP_TARGET;
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const isAdminPath = path === '/admin' || path.startsWith('/admin/');

  return (
    <EventProvider>
      {target === 'admin' || isAdminPath ? <AdminPage /> : <HomePage />}
    </EventProvider>
  );
}

export default App;
